const urlQuery = new URLSearchParams(location.search)
let paramMode = 'live'
if ( urlQuery.get('mode') == 'live' || urlQuery.get('mode') == 'stories' || urlQuery.get('mode') == 'ambassadors' ) {
  paramMode = urlQuery.get('mode')
}

const initialStateMap = {
  targetBounds: null,
  targetCenter: null,
  targetHeight: null,
  targetDuration: null,

  currentBounds: { west: -180, south: -90, east: 180, north: 90 },
  currentCenter: null,
  currentHeight: null,
  currentMagnitude: null,

  zoom: 0,
  mode: paramMode,
  showForm: false,
  cameraIsFlying: false,
}

export default initialStateMap


// WEBPACK FOOTER //
// ./src/data/map.js